import { render } from "./PreviewCMS6PageModal.vue?vue&type=template&id=c6bfcc06&scoped=true"
import script from "./PreviewCMS6PageModal.vue?vue&type=script&lang=js"
export * from "./PreviewCMS6PageModal.vue?vue&type=script&lang=js"

import "./PreviewCMS6PageModal.vue?vue&type=style&index=0&id=c6bfcc06&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6bfcc06"]])

export default __exports__